import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9ce401d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loader"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loaderBar"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}